export class StateUtil {
    static getState(zipCode) {
        const zipInt = parseInt(zipCode, 10);
        const state = STATES.find(({min, max}) => min <= zipInt && max >= zipInt);
        if (!Boolean(state)) {
            return false;
        }
        return state;
    }
}

export const STATES = [{min: 35000, max: 36999, code: 'AL', long: 'Alabama', region: 'South'},
    {min: 99500, max: 99999, code: 'AK', long: 'Alaska', region: 'West'},
    {min: 85000, max: 86999, code: 'AZ', long: 'Arizona', region: 'West'},
    {min: 71600, max: 72999, code: 'AR', long: 'Arkansas', region: 'South'},
    {min: 90000, max: 96699, code: 'CA', long: 'California', region: 'West'},
    {min: 80000, max: 81999, code: 'CO', long: 'Colorado', region: 'West'},
    {min: 6000, max: 6999, code: 'CT', long: 'Connecticut', region: 'Northeast'},
    {min: 19700, max: 19999, code: 'DE', long: 'Delaware', region: 'Northeast'},
    {min: 32000, max: 34999, code: 'FL', long: 'Florida', region: 'South'},
    {min: 30000, max: 31999, code: 'GA', long: 'Georgia', region: 'South'},
    {min: 96700, max: 96999, code: 'HI', long: 'Hawaii', region: 'West'},
    {min: 83200, max: 83999, code: 'ID', long: 'Idaho', region: 'West'},
    {min: 60000, max: 62999, code: 'IL', long: 'Illinois', region: 'Midwest'},
    {min: 46000, max: 47999, code: 'IN', long: 'Indiana', region: 'Midwest'},
    {min: 50000, max: 52999, code: 'IA', long: 'Iowa', region: 'Midwest'},
    {min: 66000, max: 67999, code: 'KS', long: 'Kansas', region: 'Midwest'},
    {min: 40000, max: 42999, code: 'KY', long: 'Kentucky', region: 'South'},
    {min: 70000, max: 71599, code: 'LA', long: 'Louisiana', region: 'South'},
    {min: 3900, max: 4999, code: 'ME', long: 'Maine', region: 'Northeast'},
    {min: 20600, max: 21999, code: 'MD', long: 'Maryland', region: 'Northeast'},
    {min: 1000, max: 2799, code: 'MA', long: 'Massachusetts', region: 'Northeast'},
    {min: 48000, max: 49999, code: 'MI', long: 'Michigan', region: 'Midwest'},
    {min: 55000, max: 56999, code: 'MN', long: 'Minnesota', region: 'Midwest'},
    {min: 38600, max: 39999, code: 'MS', long: 'Mississippi', region: 'South'},
    {min: 63000, max: 65999, code: 'MO', long: 'Missouri', region: 'Midwest'},
    {min: 59000, max: 59999, code: 'MT', long: 'Montana', region: 'West'},
    {min: 27000, max: 28999, code: 'NC', long: 'North Carolina', region: 'South'},
    {min: 58000, max: 58999, code: 'ND', long: 'North Dakota', region: 'Midwest'},
    {min: 68000, max: 69999, code: 'NE', long: 'Nebraska', region: 'Midwest'},
    {min: 88900, max: 89999, code: 'NV', long: 'Nevada', region: 'West'},
    {min: 3000, max: 3899, code: 'NH', long: 'New Hampshire', region: 'Northeast'},
    {min: 7000, max: 8999, code: 'NJ', long: 'New Jersey', region: 'Northeast'},
    {min: 87000, max: 88499, code: 'NM', long: 'New Mexico', region: 'West'},
    {min: 10000, max: 14999, code: 'NY', long: 'New York', region: 'Northeast'},
    {min: 43000, max: 45999, code: 'OH', long: 'Ohio', region: 'Midwest'},
    {min: 73000, max: 74999, code: 'OK', long: 'Oklahoma', region: 'South'},
    {min: 97000, max: 97999, code: 'OR', long: 'Oregon', region: 'West'},
    {min: 15000, max: 19699, code: 'PA', long: 'Pennsylvania', region: 'Northeast'},
    {min: 300, max: 999, code: 'PR', long: 'Puerto Rico', region: 'South'},
    {min: 2800, max: 2999, code: 'RI', long: 'Rhode Island', region: 'Northeast'},
    {min: 29000, max: 29999, code: 'SC', long: 'South Carolina', region: 'South'},
    {min: 57000, max: 57999, code: 'SD', long: 'South Dakota', region: 'Midwest'},
    {min: 37000, max: 38599, code: 'TN', long: 'Tennessee', region: 'South'},
    {min: 75000, max: 79999, code: 'TX', long: 'Texas', region: 'South'},
    {min: 88500, max: 88599, code: 'TX', long: 'Texas', region: 'South'},
    {min: 84000, max: 84999, code: 'UT', long: 'Utah', region: 'West'},
    {min: 5000, max: 5999, code: 'VT', long: 'Vermont', region: 'Northeast'},
    {min: 22000, max: 24699, code: 'VA', long: 'Virgina', region: 'South'},
    {min: 20000, max: 20599, code: 'DC', long: 'Washington DC', region: 'Northeast'},
    {min: 98000, max: 99499, code: 'WA', long: 'Washington', region: 'West'},
    {min: 24700, max: 26999, code: 'WV', long: 'West Virginia', region: 'South'},
    {min: 53000, max: 54999, code: 'WI', long: 'Wisconsin', region: 'Midwest'},
    {min: 82000, max: 83199, code: 'WY', long: 'Wyoming', region: 'West'}];